import cookies from "./cookies.md?raw";
import dpa from "./dpa.md?raw";
import partnerTerms from "./partner-terms.md?raw";
import privacy from "./privacy.md?raw";
import subprocessors from "./subprocessors.md?raw";
import terms from "./terms.md?raw";

export { terms, privacy, partnerTerms, dpa, subprocessors, cookies };

// Metadata for each document
export const termsMeta = {
	title: "Terms of Service",
	pubDate: new Date("2026-02-04"),
};

export const privacyMeta = {
	title: "Privacy Policy",
	pubDate: new Date("2026-03-01"),
};

export const partnerTermsMeta = {
	title: "Partner Terms of Service",
	pubDate: new Date("2026-02-04"),
};

export const dpaMeta = {
	title: "Data Processing Agreement",
	pubDate: new Date("2026-03-01"),
};

export const subprocessorsMeta = {
	title: "Subprocessors",
	pubDate: new Date("2026-03-01"),
};

export const cookiesMeta = {
	title: "Cookie Policy",
	pubDate: new Date("2026-03-01"),
};

/**
 * Strips frontmatter from markdown content.
 * Frontmatter is content between --- markers at the start of the file.
 */
export function stripFrontmatter(markdown: string): string {
	return markdown.replace(/^---[\s\S]*?---\n/, "");
}
